import { FunctionComponent, PropsWithChildren } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import styles from './Button.module.scss'

export type ButtonLinkProps = {
  href: string
  className?: string
  variant?: 'opacity'
  compactHover?: boolean
  disabled?: boolean
  target?: '_blank' | '_self' | '_parent' | '_top'
}
export const ButtonLink: FunctionComponent<
  PropsWithChildren<ButtonLinkProps>
> = ({
  href,
  children,
  variant,
  className,
  disabled,
  target,
  compactHover = false,
}) => {
  return (
    <Link
      href={href}
      className={cn(className, styles.container, {
        [styles.isOpacity]: variant === 'opacity',
        [styles.isDisabled]: disabled,
        [styles.isCompactHover]: compactHover,
      })}
      target={target}
    >
      <span className={styles.background}></span>
      {children}
    </Link>
  )
}
